import {popupGate} from './popupPresentation'
let hadDialog=false,notBefore=0
const visibleDialogs=()=>Array.from(document.querySelectorAll('.ant-modal-wrap,.ant-drawer-open,.c-modal-cover,.admin-image-overlay,.admin-step-tour,[data-popup-blocking]')).filter(el=>el.getClientRects().length>0 && getComputedStyle(el).visibility!=='hidden')
export function popupAvailable(owner:object,ownClass=''){
  const dialogs=visibleDialogs()
  if(hadDialog && !dialogs.length)notBefore=Date.now()+1200
  hadDialog=dialogs.length>0
  if(!popupGate.available(owner) || document.visibilityState==='hidden' || Date.now()<notBefore)return false
  return !dialogs.some(el=>!ownClass || !el.classList.contains(ownClass))
}
export function claimPopup(owner:object,ownClass=''){return popupAvailable(owner,ownClass) && popupGate.acquire(owner)}
export const releasePopup=(owner:object)=>popupGate.release(owner)

// 表单内发起二次确认时暂时隐藏父窗口，保留输入和组件状态；确认关闭后恢复。
export function suspendPopupParents(owner:object,allowOwnedError=false):(()=>void)|undefined{
  if(document.visibilityState==='hidden')return
  const parents=visibleDialogs() as HTMLElement[]
  if(!parents.length)return
  let resume:(()=>void)|undefined
  if(!popupGate.acquire(owner)){if(!allowOwnedError)return;resume=popupGate.interrupt(owner);if(!resume)return}
  const saved=parents.map(el=>({el,visibility:el.style.visibility,pointerEvents:el.style.pointerEvents}))
  saved.forEach(({el})=>{el.style.visibility='hidden';el.style.pointerEvents='none'})
  return ()=>{saved.forEach(({el,visibility,pointerEvents})=>{if(el.isConnected){el.style.visibility=visibility;el.style.pointerEvents=pointerEvents}});resume?.()}
}
